import { render } from "./PizZat.vue?vue&type=template&id=0f5fe67a"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/PizZat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f5fe67a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f5fe67a', __exports__)) {
    api.reload('0f5fe67a', __exports__)
  }
  
  module.hot.accept("./PizZat.vue?vue&type=template&id=0f5fe67a", () => {
    api.rerender('0f5fe67a', render)
  })

}


export default __exports__